import React from "react";
import { StaticQuery, graphql } from "gatsby";

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWordpressCategory {
            edges {
              node {
                name
                id
              }
            }
          }
      }
    `}
    render={data => (
        <div className="master-class-filter">
            <button className={props.filter === '' ? "category__item category__item_active" : "category__item"} filter='' onClick={e => props.click(e)}>Все</button>
            {
                data.allWordpressCategory.edges.map((item) => (
                    <button className={props.filter === item.node.name ? "category__item category__item_active" : "category__item"} key={item.node.id} filter={item.node.name} onClick={e => props.click(e)}>{item.node.name}</button>
                ))
            }
        </div>
    )}
  />
)